// extracted by mini-css-extract-plugin
export var bodySections = "_al-8";
export var gray = "_al-7";
export var green = "_al-4";
export var iconContainer = "_al-9";
export var iconWidgetContainer = "_al-1";
export var phoneIcon = "_al-2";
export var red = "_al-5";
export var statusDot = "_al-3";
export var widgetContainer = "_al-0";
export var yellow = "_al-6";